@if (showNavbar()) {
  <app-navbar />
}
@if (showSidebar()) {
  <div class="layout-body">
    <app-sidebar />
    <main class="content-area">
      <router-outlet />
    </main>
  </div>
} @else {
  @if (showNavbar()) {
    <div class="layout-body layout-body--no-sidebar">
      <main class="content-area">
        <router-outlet />
      </main>
    </div>
  } @else {
    <router-outlet />
  }
}
